import Axios, { AxiosRequestConfig, AxiosRequestHeaders } from "axios";

import store from "../lib/createStore";
import { GlobalState } from "../definitions/GlobalState";

interface AdaptAxiosRequestConfig extends AxiosRequestConfig {
  headers: AxiosRequestHeaders;
}
function authRequestInterceptor(config: AdaptAxiosRequestConfig) {
  config.headers.Accept = "application/json";
  return config;
}

const axiosMA = Axios.create({
  baseURL: "https://api2.mashop.com/",
});

axiosMA.interceptors.request.use(authRequestInterceptor);
axiosMA.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    const message = error.response?.data?.message || error.message;
    // useNotificationStore.getState().addNotification({
    //   type: 'error',
    //   title: 'Error',
    //   message,
    // });
    return Promise.reject(error);
  }
);

export { axiosMA };
